import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Conversation } from "@/types/chat";

interface ConversationsListProps {
  conversations: Conversation[];
  currentConversation: string | null;
  onConversationSelect: (id: string) => void;
  onNewConversation: () => void;
}

export function ConversationsList({
  conversations,
  currentConversation,
  onConversationSelect,
  onNewConversation,
}: ConversationsListProps) {
  return (
    <div className="w-64 flex flex-col gap-4">
      <Button onClick={onNewConversation}>New Conversation</Button>
      <ScrollArea className="flex-1 border rounded-lg p-2">
        {conversations.map((conv) => (
          <Button
            key={conv.id}
            variant={currentConversation === conv.id ? "secondary" : "ghost"}
            className="w-full justify-start"
            onClick={() => onConversationSelect(conv.id)}
          >
            {conv.title}
          </Button>
        ))}
      </ScrollArea>
    </div>
  );
}